/**
 * Last phone submitted on this device. Used only to prefill landing forms.
 * It does not grant Connect access — that follows the marketplace JWT.
 *
 * Stored as "reserve-phone" so older Rubbl Reserve devices keep the prefill.
 */
export const CONNECT_PHONE_STORAGE_KEY = "reserve-phone";

/**
 * Legacy verified-session key. No longer written. Cleared on bootstrap and logout
 * so leftover values cannot keep a provider signed into Connect.
 */
export const CONNECT_SESSION_STORAGE_KEY = "reserve-session";

/**
 * Legacy short-lived pending-code key. No longer written. Cleared on bootstrap and logout.
 */
export const CONNECT_PENDING_CODE_STORAGE_KEY = "reserve-pending-code";

/** Access-code lifetime in minutes (mirrors the Admin API's AccessCodeLifetime). */
export const CONNECT_ACCESS_CODE_MINUTES = 15;

/**
 * Last lead id seen on this device. Used to prefill landing forms, not to authenticate.
 */
export const CONNECT_LEAD_ID_STORAGE_KEY = "connect-lead-id";

/**
 * Legacy per-device access token key. Provider APIs now use an in-memory token minted
 * by `POST /lead/session` from the marketplace JWT. This key is only removed.
 */
export const CONNECT_TOKEN_STORAGE_KEY = "connect-token";

/** All leftover Connect device keys. Cleared together when the Rubbl session ends. */
export const CONNECT_AUTH_STORAGE_KEYS = [
  CONNECT_PHONE_STORAGE_KEY,
  CONNECT_SESSION_STORAGE_KEY,
  CONNECT_PENDING_CODE_STORAGE_KEY,
  CONNECT_LEAD_ID_STORAGE_KEY,
  CONNECT_TOKEN_STORAGE_KEY,
];

/**
 * Open Graph image for Rubbl Connect landing pages. Same CDN path as `common-brand-logo`
 * product="Connect" (`rubbl_connect_color.png`).
 */
export const CONNECT_OG_IMAGE =
  "https://company.rubbl.com/pubweb/marketplace/images/logos/rubbl_connect_color.png";
